import React, { useState, useEffect } from "react";
import { Form, Button, Typography, message, Spin } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import IntegerInput from "../../components/IntergerInput";
const { Title, Text } = Typography;

// Confirms the invite OTP for a person created via the multi-role Banker + BankerRoles flow.
// The link carries every assigned role id (rid=2,3,4), but confirmation matches on the single
// pre-created Banker row by email only -- there is exactly one Banker row per person.
const VerifyBankerRolesOtp = () => {
  const history = useHistory();
  const [timer, setTimer] = useState(120);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const getQueryParams = () => new URLSearchParams(location.search);
  const query = getQueryParams();
  const emailID = query.get("email");
  const bankAdminID = query.get("bid");
  let data = location.state;
  let emailId = "";
  if (data && data.email) {
    emailId = data.email;
  }

  const [email] = useState(emailId);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const onFinish = async (values) => {
    const reqObj = {
      Email: emailID,
      EmailOTP: values.otp,
      // BankAdminId: bankAdminID,
    };
    setLoading(true);
    try {
      const res = await _BankerService.confirmEmailOTPForBankerRoles(reqObj);
      if (res?.data?.IsSuccess) {
        message.success(res.data.Message);
        localStorage.setItem("BankerFirstName", res?.data?.Obj?.FirstName);
        localStorage.setItem("BankerId", res?.data?.Obj?.Id);
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        localStorage.setItem("BankerEmailId", res?.data?.Obj?.Email);
        localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
        localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);

        if (res?.data?.Obj?.IsSSOLogin == true) {
          history.push({
            pathname: routes.personalDetails.path,
            state: { email },
          });
          setLoading(false);
          return;
        }

        history.push({
          pathname: res?.data?.Obj?.IsUserExist
            ? routes.personalDetails.path
            : routes.createNewPasswordForBanker.path,
          state: { email },
        });
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const handleResendOtp = async () => {
    const reqObj = {
      Email: email,
    };
    setLoading(true);
    try {
      const res = await _BankerService.sendVerifyEmailOTP(reqObj);
      if (res?.data.IsSuccess) {
        message.success(res.data.Message);
        setTimer(120);
        setLoading(false);
      } else {
        setLoading(false);
        message.error(res.data.Message);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <Spin spinning={loading}>
      <LeftLayout>
        <div direction="vertical" size="middle" className="subBackgroundLayout  mt40">
          {/* <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
            Banker's Portal
          </Title> */}

          <Title level={3} style={{ marginBottom: 20 }}>
            Verify Your Email
          </Title>

          <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
            A six digit Verification Code was sent to <Text strong>{emailID}</Text>
          </Text>

          <Form layout="vertical" onFinish={onFinish} requiredMark={true}>
            <Form.Item
              label="Enter Verification Code" 
              name="otp"
              rules={[
                { required: true, message: "Verification Code is required" },
                {
                  pattern: /^\d{6}$/,
                  message: "Verification Code must be a 6-digit number",
                },
              ]}
            >
              <IntegerInput
                maxLength={6}
                placeholder="Enter 6-digit Verification Code"
                autoComplete="one-time-code"
              />
            </Form.Item>

            <Form.Item>
              <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
                <Button type="primary" htmlType="submit" className="w100">
                  Confirm Verification Code <RightOutlined />
                </Button>
              </div>
            </Form.Item>
          </Form>

          <Text type="secondary" style={{ display: "none", marginTop: 40 }} className="mb-10">
            Please wait 120 seconds before resending a new Verification Code:{" "}
            <span style={{ fontWeight: "bold" }}>
              00:{timer.toString().padStart(2, "0")}
            </span>
          </Text>
          <Button className="displayNone" shape="round" disabled={timer > 0} onClick={handleResendOtp}>
            Resend
          </Button>
        </div>
      </LeftLayout>
    </Spin>
  );
};

export default VerifyBankerRolesOtp;
